/** Per-browser convenience: recently used projects, most recent first (Share to Viko picker). */
const KEY = 'viko.recentProjects'
const MAX = 8

function read(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function noteRecentProject(id: string) {
  try {
    localStorage.setItem(KEY, JSON.stringify([id, ...read().filter((x) => x !== id)].slice(0, MAX)))
  } catch {
    // storage unavailable
  }
}

/** Recent first, then the rest in their given order. */
export function orderByRecent<T extends { id: string }>(projects: readonly T[]): T[] {
  const recent = read()
  const rank = (p: T) => {
    const i = recent.indexOf(p.id)
    return i < 0 ? Number.POSITIVE_INFINITY : i
  }
  return projects
    .map((p, i) => ({ p, i }))
    .sort((a, b) => rank(a.p) - rank(b.p) || a.i - b.i)
    .map((x) => x.p)
}

/** A Shortcuts `project=` value: an id, or a case-insensitive name. */
export function matchProject<T extends { id: string; name: string }>(
  projects: readonly T[],
  ref: string | undefined,
): T | undefined {
  if (!ref) return undefined
  const r = ref.trim().toLowerCase()
  return (
    projects.find((p) => p.id.toLowerCase() === r) ??
    projects.find((p) => p.name.toLowerCase() === r)
  )
}
